export default function Analytics() {
    return (
        <div>
            OrderStats
        </div>
    )
}